import { computed } from "vue"
import { ref, watch, type Ref } from "vue"

export function useBuffering <T>(modelValue: Ref<T>, props: { buffered?: boolean }) {
  if (props.buffered) {
    const modelValueInternal = ref(modelValue.value)

    watch(modelValue, (value) => modelValueInternal.value = value)

    return {
      modelValueInternal,
      updateModelValue: () => {
        modelValue.value = modelValueInternal.value
      }
    }
  } else {
    return {
      /** Delay update one extra tick */
      modelValueInternal: computed({
        get: () => modelValue.value,
        set: (value) => modelValue.value = value
      }),
      updateModelValue: () => {}
    }
  }
}